<template lang="pug">
.giftMessage.data.left(:class="{'new-item': isNew}")
  .data-general-information(@click="expand = !expand")
    .item-list
      .data-number-list(:class="{hidden: isNew}") {{ isNew ? 0 : index + 1 }}
      .data-information-list.giftMessage
        .data-info
          .data-description-list.capitalize(v-if="!history")
            span {{  data.order }} - {{ data.name }} - {{ data.phone }}

  transition.data-details-information(name="slide-fade")
    shForm.list(v-if="expand && !history" :dataOriginal="data" :fillData="true")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import shExpandButton from '@/components/elements/ExpandButton'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'GiftMessage',

  mixins: [mFilters, mForm],

  components: { shForm, shExpandButton, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      checked: false,
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.data-description-list-image-x
  height 10em

.data-description-list.sizes
  display inline-flex

.data-information-list.giftMessage
  display inline-flex
  gap 1em
  align-items center

.data-title-list.data-giftMessage
  display flex
  align-items center
  gap .3em

.data-description-list-image-brand
  height 1.2em
  display block

.data-description-list-image
  height 1.2em
</style>



// WEBPACK FOOTER //
// src/components/pages/giftMessage/GiftMessage.vue